import { FunctionComponent } from 'react';
import NumberFormat from 'react-number-format';

type amountRequestedInputProps = {
    name: string;
    value: string;
    className?: string;
    decimalScale?: number;
    errorMessage?: string;
    info?: string;
    maxRequestedValue?: number;
    placeholder?: string;
    prefix?: string;
    suffix?: string;
    size?: 'normal' | 'lg';
    onBlur(): void;
    onFocus(): void;
    onChange(value: any): void;
}

const amountRequestedInput: FunctionComponent<amountRequestedInputProps> = (props: amountRequestedInputProps) => {
    const {
        placeholder, info, maxRequestedValue, onChange, onBlur, onFocus, value, prefix, suffix,
        className, errorMessage, decimalScale = 2, size = 'normal',
    } = props;

    const classes = ['input-text'];
    const containerClasses = ['input-container'];

    if (className) {
        containerClasses.push(className);
    }

    if (value && value !== '') {
        containerClasses.push('filled');
    }

    if (Number(value) > maxRequestedValue) {
        containerClasses.push('error');
    }

    if (size === 'lg') {
        containerClasses.push('input-lg');
    }

    const handleMoneyChange = ({ floatValue }: any) => {
        onChange({ target: { value: floatValue } });
    };

    return (
        <div className="input-text-container">
            <div className={containerClasses.join(' ')}>
                <label>
                    <NumberFormat
                        className={classes.join(' ')}
                        onValueChange={handleMoneyChange}
                        value={Number(value) === 0 ? null : value}
                        prefix={prefix}
                        suffix={suffix}
                        type="tel"
                        thousandSeparator="."
                        decimalSeparator=","
                        placeholder={placeholder}
                        decimalScale={decimalScale}
                        fixedDecimalScale
                        allowNegative={false}
                        isAllowed={(values) => (!values.value.match(/^0+/))}
                        onBlur={onBlur}
                        onFocus={onFocus}
                        info={info}
                        id="loan_amount"
                    />
                </label>

                <span className="bottom" />
                { errorMessage && <span className="error-message"> {errorMessage}</span> }
                { info && <div className="info">{info}</div> }
            </div>
        </div>
    );
}

export default amountRequestedInput;
